// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "imagemodal" + "." + "05449d8fe8cc2b8a1340" + ".min.css";
};